import moment from "moment"

export const hasFinanceData = (state) => {
  return state.hasFinanceData
}

export const financeData = (state) => {
  return state.financeData
}

export const invoiceSettings = (state) => {
  return state.invoiceSettings
}

export const adRevenue = (state) => {
  if (!state.financeData) return []
  return state.financeData.map((a) => (a.audioAdRevenue || 0) + (a.displayAdRevenue || 0))
}

export const adRevenueTotal = (state, getters) => {
  return getters.audioAdRevenueTotal + getters.displayAdRevenueTotal
}

export const audioAdImpressions = (state) => {
  if (!state.financeData) return []
  return state.financeData.map((a) => a.audioAdImpressions || 0)
}

export const audioAdImpressionsTotal = (state, getters) => {
  return getters.audioAdImpressions.reduce((a, b) => a + b, 0)
}

export const audioAdRevenue = (state) => {
  if (!state.financeData) return []
  return state.financeData.map((a) => a.audioAdRevenue || 0)
}

export const audioAdRevenueTotal = (state, getters) => {
  return getters.audioAdRevenue.reduce((a, b) => a + b, 0)
}

export const displayAdImpressions = (state) => {
  if (!state.financeData) return []
  return state.financeData.map((a) => a.displayAdImpressions || 0)
}

export const displayAdImpressionsTotal = (state, getters) => {
  return getters.displayAdImpressions.reduce((a, b) => a + b, 0)
}

export const displayAdRevenue = (state) => {
  if (!state.financeData) return []
  return state.financeData.map((a) => a.displayAdRevenue || 0)
}

export const displayAdRevenueTotal = (state, getters) => {
  return getters.displayAdRevenue.reduce((a, b) => a + b, 0)
}

export const isDaily = (state) => {
  return state.financeFrequency === "daily"
}

export const timePeriods = (state, getters) => {
  if (!state.financePeriod.from || !state.financePeriod.to) return []

  const start = moment.utc(state.financePeriod.from)
  const end = moment.utc(state.financePeriod.to)
  const arr = []

  if (getters.isDaily) {
    const dt = start.clone()
    while (dt.isSameOrBefore(end, "day")) {
      arr.push(dt.format("YYYY-MM-DD"))
      dt.add(1, "day")
    }
  } else {
    const diffInMonths = Math.abs(start.diff(end, "months"))

    for (let i = 0; i <= diffInMonths; i++) {
      arr.push(start.clone().add(i, "months").format("MMM, YYYY"))
    }
  }

  return arr
}

